import { get } from '..';

const getTicket = (ticketId: string) => get(`assets/tickets/${ticketId}`);

export default getTicket;
